import React from 'react';

const ErrorBoundary = (props) => {
  return <>{props.children}</>;
};

export { ErrorBoundary };
